module Meevo.Plugins.ProductBundles {
    "use strict";
    enum AssemblyTypeEnum {
        Assemble,
        Disassemble
    }

    /**
    * Management Section
    */
    export class ManagementSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ProductBundle> {

        protected onHand: number;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            protected modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?:string

        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                null,
                sectionSecurityKey);
            // this.model = {}; // todo
        }
        /**
        * Base class override which defines what a DEFAULT model looks like.
        */
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = data;
            });
        }
        private openModal(assemblyTypeEnum: AssemblyTypeEnum, bundleId: Guid, variantId:Guid): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/productBundles/assemblyManagement/assemblyManagement.modal.html",
                controller: "meevo.plugins.productBundles.AssemblyManagementModalController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    assemblyTypeEnum,
                    quantity: assemblyTypeEnum === AssemblyTypeEnum.Assemble ? this.model['assembleValue'] : this.model['disassembleValue'],
                    bundleId,
                    variantId,
                    model: this.model                }
            };

            this.modalService.showCustom(options).then(({assemblyTypeEnum, quantity,bundleId,variantId}) => {
                if (assemblyTypeEnum === AssemblyTypeEnum.Assemble) {
                    this.model['assembleValue'] = quantity;
                } else {
                    this.model['disassembleValue'] = quantity;
                }
            });
        }
        get assemblyTypeEnum(): any {
            return AssemblyTypeEnum;
        }
    }
}